module.exports = __webpack_public_path__ + "static/img/a045.2a8d066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a045.jpg
// module id = yPvq
// module chunks = 0